import { IconProps } from './IconProps';

export const Battery = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="31"
      height="14"
      viewBox="0 0 31 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_1786_1712" fill="white">
        <rect x="2.67725" y="2" width="22.5" height="10" rx="1" />
      </mask>
      <rect
        x="2.67725"
        y="2"
        width="22.5"
        height="10"
        rx="1"
        stroke="black"
        strokeWidth="2.5"
        strokeLinejoin="round"
        mask="url(#path-1-inside-1_1786_1712)"
      />
      <path
        d="M29.4345 2.86328H28.4138V11.136H29.4345C29.9618 11.136 30.3229 10.7084 30.3229 10.1808V3.81846C30.3229 3.29092 29.9618 2.86328 29.4345 2.86328Z"
        fill="black"
      />
      <path
        d="M2.92329 14H25.1588C26.3968 14 27.4045 12.9923 27.4045 11.754V2.24604C27.4045 1.00768 26.3968 0 25.1585 0H2.92329C1.68493 0 0.677246 1.00768 0.677246 2.24604V11.7543C0.677246 12.9923 1.68493 14 2.92329 14ZM1.94997 2.24604C1.94997 1.70927 2.38652 1.27273 2.92329 1.27273H25.1588C25.6952 1.27273 26.1318 1.70927 26.1318 2.24604V11.7543C26.1318 12.2907 25.6952 12.7273 25.1585 12.7273H2.92329C2.38652 12.7273 1.94997 12.2907 1.94997 11.754V2.24604Z"
        fill="black"
      />
    </svg>
  );
};

